module.exports = __webpack_public_path__ + "5c7e1f010d039aec081a1b9625ab940d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/jcb.png
// module id = 517
// module chunks = 0